<template>
  <div class="text-xs-center" >
    <v-dialog content-class="dialog" v-model="dialog" persistent>
      
  <div class="email-background"></div>
      <v-btn class="pa-2" color="#ff5757" @click="dialog = false">Close</v-btn>
      <iframe
        id="desktop"
        sandbox="allow_scripts" 
        class="hidden-xs-only"
        data-src="https://sibforms.com/serve/MUIEAKMRFgVyc7xSQUUFV2XpdXgrEoD5hhTq8bhmJ30E_TUpH7DZ2O-w-S1M87ZWGUPFFFBV8p2zXpVoKq7Xv-6NHxp-h8EVGvFAMyISRr3Qyvdgn8muwuWvBApRHI58O5ycTKxnmojmi8NX-poN1PbkeUuRn5iGXQnbElALfs-Sm9sCXdVWCReifCLpD2xlLmFPG3cRGre6M7vT"
        frameborder="0"
        scrolling="auto"
        allowfullscreen
        style="display: block;margin-left: auto;margin-right: auto;max-width: 100%;"
      ></iframe>
      <iframe
        id="mobile"
        sandbox="allow_scripts" 
        class="hidden-sm-and-up"
        data-src="https://sibforms.com/serve/MUIEAKMRFgVyc7xSQUUFV2XpdXgrEoD5hhTq8bhmJ30E_TUpH7DZ2O-w-S1M87ZWGUPFFFBV8p2zXpVoKq7Xv-6NHxp-h8EVGvFAMyISRr3Qyvdgn8muwuWvBApRHI58O5ycTKxnmojmi8NX-poN1PbkeUuRn5iGXQnbElALfs-Sm9sCXdVWCReifCLpD2xlLmFPG3cRGre6M7vT"
        frameborder="0"
        scrolling="auto"
        allowfullscreen
        style="display: block;margin-left: auto;margin-right: auto;max-width: 100%;"
      ></iframe>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "EmailCollector",
  data: function() {
    return {
      dialog: {
        default: false,
        type: Boolean
      }
    };
  },
  created() {
    this.dialog = false;
  }
};
</script>

<style>
.dialog {
  margin: 0;
  height: 70%;
  width: 50%;
  max-height: 70%;
  max-width: 700px;
  min-height: 400px;
  position: relative;
  /* overflow: hidden; */
  
}
#desktop {
  overflow: hidden;
  width: 90%;
  height: 90%;
}

>>> #sib-container{
  box-shadow: 1px 10px 10px 1px black;
}

.email-background{
  z-index: -1;
  background-color: white;
  background-image: url('~@/assets/music background.png');
  background-size: 1000px 1409px;
  max-width: 100%;
  width: 100%;
  max-height:100%;
  position: absolute;
  top:0;
  bottom:0;
}

#mobile {
  overflow: hidden;
  height: 90%;
  width: 100%;
}

@media screen and (max-width: 1200px), screen and (max-height: 700px) {
  .v-dialog {
    margin: 0;
    height: 100%;
    width: 100%;
    max-height: 100% !important;
    min-height: 100px;
    /* overflow: hidden; */
  }
}
</style>

<style scoped>
.iframe{
  box-shadow: 5px 5px 5px 5px;
}
</style>
